import { loadScript } from '../load-strategies/VimeoSdkLoader';

export default {
  name: 'vimeo',
  loader: loadScript,
};
